import React from 'react';
import { Card, CardContent, Grid, Typography } from '@metarouter-private/mr-mui';
import PipelineTransformationsButtons from './PipelineTransformationsButtons';
import { DrawerContextProvider } from 'app/shared/contexts/drawer';
import PipelineTransformationsDrawer from './PipelineTransformationsDrawer';

export default function PipelineTransformationsSection() {
  return (
    <DrawerContextProvider>
      <Card variant="outlined">
        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h6">Pipeline Configuration</Typography>
            </Grid>
            <Grid item xs="auto">
              <PipelineTransformationsButtons />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <PipelineTransformationsDrawer />
    </DrawerContextProvider>
  );
}
